'use client';

import { useMounted } from '#/hooks';
import { useContextcustom } from '#/hooks/use-context-menu';
import { Card, CardContent } from '../ui/card';

export const ContextMenuCustom = () => {
  const { isOpen, pageY, pageX, contents } = useContextcustom();

  const mounted = useMounted();

  if (!mounted) {
    return null;
  }

  if (isOpen) {
    return (
      <Card
        id="context-menu"
        className="py-2"
        style={{
          position: 'fixed',
          top: pageY,
          left: pageX,
          zIndex: 100
        }}
      >
        <CardContent className="px-2 text-sm">{contents}</CardContent>
      </Card>
    );
  }
};
